import { $GQL } from '@GQL/index';
import { currency, capitalize, percentage } from '@/lib/Filters';

export async function getOffersAsOptions(params: { mpid: string; }) {
    const query = `
    query GetOffersAsOptions($params: OffersParams) {
        offers: offersV2(params: $params) {
            id
            name
            trigger
            required_funding
            credit_amount
            credit_type
        }
    }       
    `;

    const result = await $GQL.request(query, {
        params,
    });

    return result.offers.map((row) => {
        return {
            value: row.id,
            label: `${row.name} - ${capitalize(row.credit_type)}, Amount: ${row.credit_type === 'percentage' ? percentage(row.credit_amount, 2) : currency(row.credit_amount)}, Min: ${currency(row.required_funding, true)}`,
        };
    });
}
